export default __webpack_public_path__ + "static/media/2.930a1122.png";